import { usePageMeta } from "../lib/seo";

const DEFAULT_MESSAGE =
  "MarketOnBase is temporarily down for maintenance. Please check back shortly.";

/** Full-page takeover shown across the entire public site while maintenance mode is on — see
 *  AppShell's gate and apps/api's maintenanceGate middleware, which blocks the underlying API
 *  routes too so this isn't just a frontend-only illusion of downtime. */
export function MaintenancePage({ message }: { message: string | null }) {
  usePageMeta({
    title: "Maintenance",
    description: "MarketOnBase is briefly down for maintenance.",
    path: "/",
    index: false,
  });

  return (
    <div className="stack" style={{ maxWidth: 480, margin: "120px auto 0", textAlign: "center" }}>
      <h1>Be right back</h1>
      <p className="muted">{message || DEFAULT_MESSAGE}</p>
    </div>
  );
}
